import { render, staticRenderFns } from "./footerContentComponent.vue?vue&type=template&id=02364448"
import script from "./footerContentComponent.vue?vue&type=script&lang=js"
export * from "./footerContentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports